import './addons/mdb-vector-map'
import './addons/moment.min'
import './addons/fullcalendar.min'
import './addons/wysiwyg'
import '../../js/vendor/addons/datatables2'
import '../../js/vendor/addons/datatables-select2'